export class UserSettingsOther {
  arePagesAfterShown: boolean = false
  arePagesBeforeShown: boolean = false
  areQuestionsShown: boolean = false
  availabilityImgUrl: string = ""
  baseImgixUrl: string = ""
  baseS3Url: string = ""
  currentUserId: string = ""
  customerId: number = 1
  firstName: string = ""
  itemsPerPage: number = 0
  mainMenuCollapsed: boolean = false
  navbarCollapsed: boolean = false
  picture: string = ""
  secondName: string = ""
  username: string = ""
  userFirstName: string = ""
}
